import styled from 'styled-components';

import { lighten } from 'polished';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 10px 20px 20px;
  }
`;

export const Header = styled.div`
  margin-bottom: 25px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #101d40;
  }

  p {
    color: #7c8db5;
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const SizesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 25px;
`;

export const SizeItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  height: 200px;
  width: 151px;
  padding: 9px;
  border: 2px solid #e6effb;
  background-color: #ffffff;
  font-family: 'Sora', sans-serif;
`;

export const SizeItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;

  h3 {
    font-size: 14px;
    font-weight: 600;
    color: #101d40;
    margin-bottom: 8px;
  }

  p {
    font-size: 13px;
    color: #7c8db5;

    & + p {
      margin-top: 3px;
    }
  }
`;

export const EditSizesButton = styled(Link)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 18px;
  border-radius: 5px;
  font-family: 'Sora', sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #329bfc;
  border: none;
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;
  outline: 2px solid #329bfc;
  outline-offset: -2px;
  width: fit-content;
  text-decoration: none;

  svg {
    margin-right: 6px;
  }

  &:hover:not(:disabled) {
    background-color: ${lighten(0.38, '#329bfc')};
  }

  &:disabled {
    outline-color: rgba(0, 0, 0, 0.12);
  }
`;
